import { render, staticRenderFns } from "./HelpCenterVersions.vue?vue&type=template&id=1fb31cd4&scoped=true&"
import script from "./HelpCenterVersions.vue?vue&type=script&lang=ts&"
export * from "./HelpCenterVersions.vue?vue&type=script&lang=ts&"
import style0 from "./HelpCenterVersions.vue?vue&type=style&index=0&id=1fb31cd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb31cd4",
  null
  
)

export default component.exports